export const LANGUAGE_STORAGE_KEY = 'restaurant_language';
export const LANGUAGE_BUTTON_COUNT = 4;

export interface LanguageOption {
  code: string;
  name: string;
}

export interface BackendLanguage {
  code?: string;
  name?: string;
  sort?: number;
}

// Preserve the API locale. These are protocol aliases, not UI dictionaries.
export function toApiLanguage(code: unknown): string | undefined {
  if (typeof code !== 'string') return undefined;
  const value = code.trim().replace(/_/g, '-');
  if (!/^[a-z]{2,3}(?:-[a-z0-9]{2,8})*$/i.test(value)) return undefined;
  const aliases: Record<string, string> = { en: 'en', es: 'es', zh: 'zh-CN', 'zh-cn': 'zh-CN' };
  return aliases[value.toLowerCase()] ?? value;
}

export function fallbackLanguages(): LanguageOption[] {
  return [{ code: 'en', name: 'English' }];
}

export function backendLanguages(rows: readonly BackendLanguage[]): LanguageOption[] {
  // English is the only fixed button. Keep the API's order for all others.
  const languages = fallbackLanguages();
  const seen = new Set(['en']);
  for (const row of rows) {
    if (languages.length === LANGUAGE_BUTTON_COUNT) break;
    if (!row || typeof row !== 'object') continue;
    const code = toApiLanguage(row?.code);
    if (!code || seen.has(code.toLowerCase())) continue;
    const name = typeof row.name === 'string' ? row.name.trim() : '';
    languages.push({ code, name: name || code });
    seen.add(code.toLowerCase());
  }
  return languages;
}

export function getSavedApiLanguage(): string {
  try {
    // Preserve backend alternatives across reloads. The loaded catalog validates
    // whether the saved code is still one of the visible choices.
    return toApiLanguage(localStorage.getItem(LANGUAGE_STORAGE_KEY)) ?? 'en';
  } catch {
    return 'en';
  }
}
